import React from "react";
import styles from "../styles/vinos.module.css";
import { IoPrintOutline } from "react-icons/io5";
import { buildPrintUrl, STAGE_LIMIT } from "../domain/vinosSelection";

export default function VinosActionsBar({
    selection,
    autoPrint,
    onClearSelection,
    onCreate,
}) {
    const disabled =
        (selection?.ap?.length || 0) === 0 &&
        (selection?.pr?.length || 0) === 0 &&
        (selection?.po?.length || 0) === 0;

    const openPrintSelection = () => {
        const url = buildPrintUrl(selection, autoPrint);
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className={styles["actions-row"]} style={{ alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <span className={styles.pill}>Aperitivo: {(selection?.ap?.length || 0)}/{STAGE_LIMIT}</span>
                <span className={styles.pill}>1º Plato: {(selection?.pr?.length || 0)}/{STAGE_LIMIT}</span>
                <span className={styles.pill}>Postre: {(selection?.po?.length || 0)}/{STAGE_LIMIT}</span>
            </div>

            <div
                className={styles["actions-right"]}
                style={{ marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}
            >
                <button
                    type="button"
                    className={`${styles.btn} ${styles.primary}`}
                    onClick={openPrintSelection}
                    disabled={disabled}
                    title="Imprimir selección (ES+EN)"
                >
                    <IoPrintOutline style={{ fontSize: "20px" }} /> Imprimir selección (ES+EN)
                </button>

                <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={onClearSelection}>
                    Limpiar selección
                </button>
            </div>

            <button type="button" className={`${styles.btn} ${styles.primary}`} onClick={onCreate}>
                + Nuevo vino
            </button>
        </div>
    );
}
